import { inject, observer } from "mobx-react";
import AccountComponent from "../../components/UserManagement/Account/AccountComponent";

const Account = inject('userStore','sharedStore', 'loginStore')(observer(AccountComponent));

export default Account;